import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Date/time range modal for area reports. The confirm button id ("reporetArea")
// is bound by the car menu through jQuery, so it stays inside this template.
@Component({
  selector: 'area-report-modal',
  templateUrl: './area-report-modal.component.html',
  styleUrls: ['./area-report-modal.component.css'],
})
export class AreaReportModalComponent {
  @Input() formFrom: FormGroup;
  @Input() formTo: FormGroup;
}
